export class ConsultancyListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            consultancy: lang.consultancy[0],        
            code: lang.consultancy[3],        
            customer: lang.consultancy[4],               
            typeofContract: lang.consultancy[5],               
            startingDate: lang.consultancy[6],               
            meetingsper: lang.consultancy[7],               
            contract: lang.consultancy[8],               
            amount: lang.consultancy[9],               
            action: lang.consultancy[10],               
            erase: lang.consultancy[100],               
            modify: lang.consultancy[97],               
            view: lang.consultancy[101],               
            createnew: lang.consultancy[2],               
            submit: lang.consultancy[67],               
            selectCustomer: lang.consultancy[106],               
            contract_type: lang.consultancy[5],               
            RSPP: lang.consultancy[84],               
            DT: lang.consultancy[85],               
            QLT: lang.consultancy[86],               
            SIC: lang.consultancy[87],               
            ODV: lang.consultancy[88],               
            Other: lang.consultancy[89],                      
            selectColumns: lang.general[9],                      
            selectAll: lang.general[10],                      
            activeColumns: lang.general[11],                      
            close: lang.general[17],                      
            exportCSV: lang.general[13],                      
            exportPDF: lang.general[14],                      
            exportExcel: lang.general[15],                      
            print: lang.general[16],                      
            editConsultancy: lang.consultancy[94],                      
        }

    } 

    lang() {
        return this.variables;
    }

}

export class ConsultancyViewListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            consultancy: lang.consultancy[0],        
            code: lang.consultancy[3],        
            customer: lang.consultancy[4],               
            typeofContract: lang.consultancy[5],               
            startingDate: lang.consultancy[6],               
            meetingsper: lang.consultancy[7],               
            contract: lang.consultancy[8],               
            amount: lang.consultancy[9],               
            action: lang.consultancy[10],               
            erase: lang.consultancy[100],               
            modify: lang.consultancy[97],               
            view: lang.consultancy[101],               
            createnew: lang.consultancy[2],               
            submit: lang.consultancy[67],               
            selectCustomer: lang.consultancy[106],               
            contract_type: lang.consultancy[5],               
            RSPP: lang.consultancy[84],               
            DT: lang.consultancy[85],               
            QLT: lang.consultancy[86],               
            SIC: lang.consultancy[87],               
            ODV: lang.consultancy[88],               
            Other: lang.consultancy[89],                      
            selectColumns: lang.general[9],                      
            selectAll: lang.general[10],                      
            activeColumns: lang.general[11],                      
            close: lang.general[17],                      
            exportCSV: lang.general[13],                      
            exportPDF: lang.general[14],                      
            exportExcel: lang.general[15],                      
            print: lang.general[16],
            generalData: lang.consultancy[11],
            type: lang.consultancy[16],
            viewConsultancy: lang.consultancy[66],
            planning: lang.consultancy[12],
            reportNo: lang.consultancy[22],
            date: lang.consultancy[15],
            performedBy: lang.consultancy[17],
            totalHours: lang.consultancy[33],
            pdfReport: lang.consultancy[18],
            distributionStatus: lang.consultancy[19],
            sendTo: lang.consultancy[20],
            dateOfsend: lang.consultancy[21],
            createInterventionreport: lang.consultancy[46],
            mail: lang.general[5],
            selectType: lang.consultancy[74],
            documentFound: lang.consultancy[25],
            activites_schedule: lang.consultancy[26],
            notes: lang.consultancy[27],
            performedActivities: lang.consultancy[23],
            workActivity: lang.consultancy[24],
            createPdf: lang.consultancy[90],
            doyouDeletethis: lang.general[71],
            removeallSelected: lang.general[72],
            multiduplicateSelected: lang.general[74],
            editInterventionReport: lang.general[118],
            tasktobeDone: lang.consultancy[123],
            input: lang.consultancy[36],
            levelofRisk: lang.consultancy[37],
            dateofCreation: lang.consultancy[38],
            expectedClosing: lang.consultancy[39],
            daysLeft: lang.consultancy[40],
            closingDate: lang.consultancy[62],
            status: lang.consultancy[41],
            responsible: lang.consultancy[43],
            createTask: lang.consultancy[47],
            createTasktobeDone: lang.consultancy[60],
            slight: lang.consultancy[75],
            medium: lang.consultancy[76],
            high: lang.consultancy[77],
            documentAttachment: lang.consultancy[55],
            save: lang.consultancy[63],
            requiredField: lang.general[26],
            edittasktobeDone: lang.consultancy[122],
            documents: lang.consultancy[13],
            addDocument: lang.consultancy[128],
            protocol: lang.consultancy[14],
            deleteConfirmation: lang.general[76],
            multiDelete: lang.general[77],
            multiDuplicate: lang.general[78],
            downloadReport: lang.consultancy[131],
            closeTask: lang.consultancy[132],
            activitiesClosure: lang.consultancy[61],
            languageSelection: lang.consultancy[129],
            chooseLang : lang.consultancy[130],
            selectYear : lang.consultancy[107],
            editIntervention : lang.consultancy[118],
            viewPlanning : lang.consultancy[120],

        }

    }

    lang() {
        return this.variables;
    }

}


export class ConsultancyViewDocumentsLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            documents: lang.consultancy[13],
            addDocument: lang.consultancy[128],
            code: lang.consultancy[3],
            title: lang.consultancy[50],
            revision: lang.consultancy[51],
            date: lang.consultancy[15],
            writtenBy: lang.consultancy[52],
            documentStatus: lang.consultancy[53],
            attachments: lang.consultancy[54],
            action: lang.consultancy[10],
            exportCSV: lang.general[13],                      
            exportPDF: lang.general[14],                      
            exportExcel: lang.general[15],                      
            print: lang.general[16],                      
            selectColumns: lang.general[9],                      
            selectAll: lang.general[10],                      
            activeColumns: lang.general[11],                      
            close: lang.general[17],
            erase: lang.consultancy[100],               
            modify: lang.consultancy[97],               
            view: lang.consultancy[101],               
            documentAttachment: lang.consultancy[55],               
            approved: lang.consultancy[78],               
            notapproved: lang.consultancy[79],               
            awaitingApproved: lang.consultancy[80],               
            save: lang.consultancy[63],               
            type: lang.consultancy[16],
            topics: lang.consultancy[56],
            description: lang.consultancy[57],
            addresser: lang.consultancy[58],
            addressee: lang.consultancy[59],
            protocol: lang.consultancy[14],
            addprotocol: lang.consultancy[64],
            editprotocol: lang.consultancy[126],
            viewprotocol: lang.consultancy[127],
            consultancyCode: lang.consultancy[81],
            incoming: lang.consultancy[82],
            outcoming: lang.consultancy[83],
            pleaseSelect: lang.consultancy[96],
            requiredField: lang.general[26],
            editDocument: lang.consultancy[124],
            viewDocument: lang.consultancy[125],

        }

    }

    lang() {
        return this.variables;
    }

}


export class ConsultancyViewProtocolLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            documents: lang.consultancy[13],
            addDocument: lang.consultancy[128],
            code: lang.consultancy[3],
            title: lang.consultancy[50],
            revision: lang.consultancy[51],
            date: lang.consultancy[15],
            writtenBy: lang.consultancy[52],
            documentStatus: lang.consultancy[53],
            attachments: lang.consultancy[54],
            action: lang.consultancy[10],
            exportCSV: lang.general[13],                      
            exportPDF: lang.general[14],                      
            exportExcel: lang.general[15],                      
            print: lang.general[16],                      
            selectColumns: lang.general[9],                      
            selectAll: lang.general[10],                      
            activeColumns: lang.general[11],                      
            close: lang.general[17],
            erase: lang.consultancy[100],               
            modify: lang.consultancy[97],               
            view: lang.consultancy[101],               
            documentAttachment: lang.consultancy[55],               
            approved: lang.consultancy[78],               
            notapproved: lang.consultancy[79],               
            awaitingApproved: lang.consultancy[80],               
            save: lang.consultancy[63],               
            type: lang.consultancy[16],
            topics: lang.consultancy[56],
            description: lang.consultancy[57],
            addresser: lang.consultancy[58],
            addressee: lang.consultancy[59],
            protocol: lang.consultancy[14],
            addprotocol: lang.consultancy[64],
            editprotocol: lang.consultancy[126],
            viewprotocol: lang.consultancy[127],
            consultancyCode: lang.consultancy[81],
            incoming: lang.consultancy[82],
            outcoming: lang.consultancy[83],
            pleaseSelect: lang.consultancy[96],
            requiredField: lang.general[26],

        }

    }

    lang() {
        return this.variables;
    }

}



export class ConsultancyCalendarLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            description: lang.consultancy[57],
            type: lang.consultancy[16],
            month: lang.general[29],
            week: lang.general[28],
            day: lang.general[27],
            brand: lang.consultancy[3],
            model: lang.consultancy[4],
            matricolaNumber: lang.consultancy[137],
            factoryNumber: lang.consultancy[138],
            referringPlancode: lang.consultancy[139],
            planDescription: lang.consultancy[140],
            submit: lang.general[37],
            date: lang.consultancy[15],
            title: lang.consultancy[50],
            requiredField: lang.general[26],
            close: lang.general[17],
        }

    }

    lang() {
        return this.variables;
    }

}


export class ConsultancyReportListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            documents: lang.consultancy[13],
            addDocument: lang.consultancy[128],
            code: lang.consultancy[3],
            title: lang.consultancy[50],
            revision: lang.consultancy[51],
            date: lang.consultancy[15],
            writtenBy: lang.consultancy[52],
            documentStatus: lang.consultancy[53],
            attachments: lang.consultancy[54],
            action: lang.consultancy[10],
            exportCSV: lang.general[13],                
            exportPDF: lang.general[14],                      
            exportExcel: lang.general[15],                      
            print: lang.general[16],                      
            selectColumns: lang.general[9],                      
            selectAll: lang.general[10],                      
            activeColumns: lang.general[11],                      
            close: lang.general[17],
            erase: lang.consultancy[100],               
            modify: lang.consultancy[97],               
            view: lang.consultancy[101],               
            documentAttachment: lang.consultancy[55],               
            approved: lang.consultancy[78],               
            notapproved: lang.consultancy[79],               
            awaitingApproved: lang.consultancy[80],               
            save: lang.consultancy[63],               
            type: lang.consultancy[16],
            topics: lang.consultancy[56],
            description: lang.consultancy[57],
            addresser: lang.consultancy[58],
            addressee: lang.consultancy[59],
            protocol: lang.consultancy[14],
            addprotocol: lang.consultancy[64],
            reportno: lang.consultancy[22],
            customer: lang.consultancy[4],
            performedBy: lang.consultancy[17],
            performedActivities: lang.consultancy[23],
            totalHours: lang.consultancy[33],
            kmTraveled: lang.consultancy[30],
            costofBoard: lang.consultancy[29],
            otherCosts: lang.consultancy[28],
            consultancyCode:lang.consultancy[81],
            employees:lang.consultancy[112],
            dateFrom:lang.consultancy[110],
            dateTo:lang.consultancy[111],
            reporting: lang.general[55],
            projReporting: lang.general[62],

        }

    }

    lang() {
        return this.variables;
    }

}


